import { BorderRight } from "@mui/icons-material";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "customerAddressIsSetAsDefault",
            label: "Single Freight,Insurance & other charges for all Invoices",
            component: "checkboxbox",
          },
        ],
        row2: [
          {
            name: "importInvoiceOtherDetailsContractno",
            component: "hr",
          },
        ],
        row3: [
          {
            name: "Miscellaneous Chrgs.",
            actionText: "Miscellaneous Chrgs.",
            component: "typographytext",
            width: "15%",
          },
          {
            name: "Miscellaneouscurrency",
            label: "Currency",
            component: "text-field",
            endIconName: LuChevronDown,
            width: "18%",
            type: "autocomplete",
            endpoint: "getExchange",
            autofillTargets: {
              exchgRate: "importrate",
            },
          },
          {
            name: "Miscellaneousexrate",
            label: "Exch Rate",
            component: "text-field",
            width: "18%",
          },
          {
            name: "Miscellaneousrate",
            label: "Rate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Miscellaneousamount",
            label: "Amount",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousremark",
            label: "Remark",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
        ],

        row4: [
          {
            name: "Agency",
            actionText: "Agency",
            component: "typographytext",
            width: "15%",
            sx: { mt: 4 },
          },
          {
            name: "agencycurrency",
            component: "text-field",
            width: "18%",
            type: "autocomplete",
            endpoint: "getExchange",
            autofillTargets: {
              exchgRateA: "importrate",
            },
          },
          { name: "AgencyexchgRate", component: "text-field", width: "18%" },
          {
            name: "Agencyrate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Agencyamount",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "-",
            component: "typographytext",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
        ],

        row5: [
          {
            name: "Discount	",
            actionText: "Discount, if any	",
            component: "typographytext",
            width: "15%",
            sx: { mt: 4 },
          },
          {
            name: "Discountcurrency",
            component: "text-field",
            width: "18%",
            disabled: true,
          },
          { name: "DiscountexchgRate", component: "text-field", width: "18%" },
          {
            name: "Discountrate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Discountamount",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Discountremark",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
        ],
        row6: [
          {
            name: "Loading",
            actionText: "Loading",
            component: "typographytext",
            width: "15%",
            sx: { mt: 4 },
          },
          {
            name: "Loadingcurrency",
            component: "text-field",
            width: "18%",
            type: "autocomplete",
            endpoint: "getExchange",
            autofillTargets: {
              exchgRateCsas: "importrate",
            },
          },
          { name: "LoadingexchgRate", component: "text-field", width: "18%" },
          {
            name: "Loadingrate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },

          {
            name: "Loadingamount",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "-",
            component: "typographytext",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
        ],
      },
    },
    {
      column: "column2",
      rows: {
        row1: [
          {
            name: "importInvoiceOtherDetailsContractno",
            component: "hr",
          },
        ],
        row2: [
          {
            name: "Freight",
            actionText: "Freight",
            component: "typographytext",
            width: "15%",
            sx: { mt: 4 },
          },
          {
            name: "Freightcurrency",
            component: "text-field",
            endIconName: LuChevronDown,
            width: "18%",
            type: "autocomplete",
            endpoint: "getExchange",
            autofillTargets: {
              exchgcasaRate: "importrate",
            },
          },
          {
            name: "FreightexchangeRate",
            component: "text-field",
            width: "18%",
          },
          {
            name: "Freightrate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Freightamount",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          { name: "-", component: "typographytext", width: "18%" },
        ],

        row3: [
          {
            name: "Insurance",
            actionText: "Insurance",
            component: "typographytext",
            width: "15%",
            sx: { mt: 4 },
          },
          {
            name: "Insurancecurrency",
            component: "text-field",
            width: "18%",
            type: "autocomplete",
            endpoint: "getExchange",
            autofillTargets: {
              exchgRacsacateA: "importrate",
            },
          },
          {
            name: "Insuranceexchangerate",
            component: "text-field",
            width: "18%",
          },
          {
            name: "Insurancerate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            // disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Insuranceamoud",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "-",
            component: "typographytext",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
        ],

        row4: [
          {
            name: "Addl Chrg(High Sea)",
            actionText: "Addl Chrg(High Sea)",
            component: "typographytext",
            width: "15%",
            sx: { mt: 4 },
          },
          {
            name: "Addlcurrency",
            component: "text-field",
            width: "18%",
            disabled: true,
            defaultValue: "INR",
          },
          { name: "Addlexchangerate", component: "text-field", width: "18%" },
          {
            name: "Addlrate",
            component: "text-field",
            // afterText: "%", //
            width: "25%",
            placeholder: "0.00",
            dataType: "float",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Addlamount",
            component: "text-field",
            width: "18%",
            disabled: true,
            placeholder: "0.00",
            dataType: "float",
          },
          { name: "-", component: "typographytext", width: "18%" },
        ],
        row5: [
          {
            name: "Revenue Deposit",
            actionText: "Revenue Deposit",
            component: "typographytext",
            width: "12.5%",
            sx: { mt: 4 },
          },
          {
            name: "Revenuerate",
            component: "text-field",
            //  afterText: "% On",
            width: "25%",
          },
          {
            name: "Miscellaneousrate",
            actionText: "% On",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
          {
            name: "Revenueremark",
            component: "dropdown",
            width: "18%",
            options: [
              {label: "Assessable",value: "Assessable"},
              {label: "Duty",value: "Duty"},
              {label: "Assessable&Duty",value: "Assessable&Duty"},
            ],
          },
        ],
        row6: [
          {
            name: "Landing Charge	",
            actionText: "Landing Charge	",
            component: "typographytext",
            width: "12.6%",
            sx: { mt: 4 },
          },
          {
            name: "Landingrate",
            component: "text-field",
            // afterText: "%", //
            width: "22.5%",
          },
          {
            name: "Miscellaneousrate",
            actionText: "%",
            component: "typographytext",
            sx: { mt: 4 , ml: -1  },
          },
        ],
      },
    },
  ],
};
